export default __webpack_public_path__ + "static/media/arrowUp.fb74bb8a.svg";